import { render, staticRenderFns } from "./LegacySummaryCard.vue?vue&type=template&id=209c60b6&scoped=true"
import script from "./LegacySummaryCard.vue?vue&type=script&lang=js"
export * from "./LegacySummaryCard.vue?vue&type=script&lang=js"
import style0 from "./LegacySummaryCard.vue?vue&type=style&index=0&id=209c60b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209c60b6",
  null
  
)

export default component.exports